import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../constants/actionTypes';
import PropTypes from 'prop-types'
import { actions as locationTaskActions } from '../../actions/locationTaskActions';
import Drawer from '../Common/Drawer/Drawer';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Notification from '../Common/Notification';

export class BulkUpdateStatusDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedStatusId: "",
            isFormValid: true
        }
    }

    changeStatus = (id) => {
        this.setState({ selectedStatusId: id });
    }

    onSave = async () => {
        if(this.state.selectedStatusId){
            try {
                let taskIds = this.props.locationTasks.map(m => m.id);

                const response = await this.props.locationTaskActions.updateStatus(taskIds, this.state.selectedStatusId);
                if (response.type === types.UPDATE_LOCATION_TASK_LIST_STATUS_SUCCESS) {
                    
                    Notification("success", "Status Updated", "New Status has been set");
                    this.props.onComplete();
    
                } else if (response.type === types.UPDATE_LOCATION_TASK_LIST_STATUS_FAILURE) {
                    Notification("error", "Error", response.payload.message);
                }
            } catch (error) {
                Notification("error", "Error", error);
            }
            
        }else{
            this.setState({ isFormValid: false });
        }
    }

    render() {

        return (
            <Drawer isOpen={true} isWide={false} title='Bulk Update Status'
                onSaveClick={this.onSave}
                saveText='Save'
                onCancelClick={this.props.onCancel}>

                <form noValidate className={this.state.isFormValid ? "" : "was-validated"} >
                    <MultiSelectBox 
                        name="status" 
                        label="Status" 
                        idField="id" 
                        valueField="name" 
                        selectedValues={this.state.selectedStatusId.toString()}
                        options={this.props.statuses}
                        isRequired={true}
                        errorMessage="Choose a status"
                        isMulti={false} 
                        onChange={this.changeStatus}
                    />                
                </form>
 

            </Drawer>
        )
    }
}

BulkUpdateStatusDrawer.propTypes = {
    locationTaskActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    statuses: PropTypes.array.isRequired,
    locationTasks: PropTypes.array
};

function mapDispatchToProps(dispatch) {
    return {
        locationTaskActions: bindActionCreators(locationTaskActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(BulkUpdateStatusDrawer);
